import { css } from 'emotion'

export const TagDisplayNameSpanStyles = css``
